import React, { useState, useEffect } from 'react';
import EditarRendimiento from './EditarRendimiento';

const RendimientosSection = (p) => {
    const data = [...p.data];
    const [edit, setedit] = useState(null);
    const [newReg, setnewReg] = useState(false);

    const keys = [
        { key: 'area_nombre', name: 'ÁREA' },
        { key: 'labor_nombre', name: 'LABOR' },
        { key: 'um_nombre', name: 'UNIDAD MEDIDA' },
        { key: 'unidad_hora', name: 'UNIDAD HORA' },
        { key: 'pago_unidad', name: 'PAGO POR UNIDAD' }
    ];
    const closeEdit = () => { setnewReg(false); setedit(null); }
    const editarRendieminto = (dt) => {
        setedit(dt);
    }


    return (
        <>
            <div className='w-100 text-center p-0 mt-3 round-l overflow' style={{ height: "78vh" }}>

                <div className='row justify-content-evenly w-100 m-0 p-0'>
                    <table className='table table-sm table-hover p-0 m-0 bw-900'>
                        <thead>
                            <tr>
                                {keys.map((k, i) => <th key={i} scope='col' className='text-blue4 nowrap'>{k.name}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((d, i) =>
                                <tr key={i + "erfd"} className={`pointer nowrap ${d.estado === "ACTIVO" ? '' : 'opacity-40'}`} onClick={() => { editarRendieminto(d) }}>
                                    {keys.map((k, j) => <td key={j + "ddd" + i}>{d[k.key]}</td>)}
                                </tr>
                            )}

                        </tbody>
                    </table>
                    <div className='w-100'></div>
                    <button className='btn btn-light shadow bw-400 mt-3 mb-5 round-xxl border border-warning border-2 text-bold' onClick={() => { setnewReg(true) }}>Nuevo registro</button>

                </div>

            </div>
            {(newReg || edit) && <EditarRendimiento data={edit} close={closeEdit} inputs={p.inputs} update={p.update} />}
        </>

    )
}

export default RendimientosSection;